import { render, staticRenderFns } from "./EditorMarkerActions.vue?vue&type=template&id=d6202a4c&scoped=true"
import script from "./EditorMarkerActions.vue?vue&type=script&lang=ts"
export * from "./EditorMarkerActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6202a4c",
  null
  
)

export default component.exports